exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{margin:0;height:100vh;background-color:#f1f4f6}#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;height:100%;display:flex;flex-direction:column}.full-fade-enter-active,.full-fade-leave-active{transition:opacity 1s;position:absolute;top:0;left:0;width:100%;height:100%}.full-fade-enter,.full-fade-leave-to{opacity:0;position:absolute;top:0;left:0;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-84bbd8a6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 167
// module chunks = 0